var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3456 11.4372C21.3456 10.8292 21.8385 10.3363 22.4465 10.3363H29.7859C30.394 10.3363 30.8869 10.8292 30.8869 11.4372C30.8869 12.0452 30.394 12.5381 29.7859 12.5381H22.4465C21.8385 12.5381 21.3456 12.0452 21.3456 11.4372Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3456 15.107C21.3456 14.499 21.8385 14.0061 22.4465 14.0061H26.1162C26.7242 14.0061 27.2171 14.499 27.2171 15.107C27.2171 15.715 26.7242 16.2079 26.1162 16.2079H22.4465C21.8385 16.2079 21.3456 15.715 21.3456 15.107Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3883 8.86846C13.5743 8.86846 8.86846 13.5743 8.86846 19.3883C8.86846 25.2023 13.5743 29.9082 19.3883 29.9082C25.2023 29.9082 29.9082 25.2023 29.9082 19.3883C29.9082 18.7803 30.4011 18.2874 31.0091 18.2874C31.6172 18.2874 32.11 18.7803 32.11 19.3883C32.11 26.4184 26.4184 32.11 19.3883 32.11C12.3583 32.11 6.66663 26.4184 6.66663 19.3883C6.66663 12.3583 12.3583 6.66663 19.3883 6.66663C19.9964 6.66663 20.4893 7.15952 20.4893 7.76754C20.4893 8.37556 19.9964 8.86846 19.3883 8.86846Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0074 29.0074C29.4373 28.5775 30.1344 28.5775 30.5643 29.0074L33.0108 31.4539C33.4407 31.8838 33.4407 32.5809 33.0108 33.0108C32.5809 33.4407 31.8838 33.4407 31.4539 33.0108L29.0074 30.5643C28.5775 30.1344 28.5775 29.4373 29.0074 29.0074Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconMenu);
export default __webpack_public_path__ + "static/media/searchIconMenu.2715303e.svg";
export { ForwardRef as ReactComponent };